import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/text-banking")({
	component: TextBankingLayout,
});

function TextBankingLayout() {
	return <Outlet />;
}
